import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import BaseComponent from '../../../../baseClasses/BaseComponent'; 
import DataSource from '../../../../dao/DataSource/DataSource';
import PORLocationChildCard from '../PORLocationChildCard';
import './PORProjectParentCard.scss';
import anime from 'animejs';

// TODO: reduce complexity in this component
class PORProjectParentCard extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { 
    };

    this.expandCard = this.expandCard.bind(this);
    this.collapseCard = this.collapseCard.bind(this);
    this.createLocationCards = this.createLocationCards.bind(this);
  }
  
  handleProjectRetrieval(project, action, acData, fetchedData) {
    this.setState({ project, locations: project.all_locations });
  }

  componentDidMount() {
    super.componentDidMount(this);

    this.setState({ expanded: this.props.expanded });
    this.projectDataSource = new DataSource('Project', this.props.project.id, {}, this.handleProjectRetrieval);
    this.projectDataSource.get();
  }

  componentWillUnmount() {
    if (this.projectDataSource) {
      this.projectDataSource.release();
      this.projectDataSource = null;
    }
  }

  componentDidUpdate(prevProps) {
  }

  handleSelectLocation(location, project) {
    if (this.props.selectLocation) {
      this.props.selectLocation(location, project);
    }
  }

  handleProjectSelection(select, ignoreSelection) {
    const { selectProject } = this.props;
    const { project } = this.state;
    if (selectProject && !ignoreSelection) {
      selectProject(project, false);
    }
  }

  handleProjectExpandContract() {
    const { project } = this.state;
    if (this.state.expanded) {
      this.setState({ expanded: false });
    }
    else {
      if (project.location) {
        this.setState({ locations: project.all_locations }, () => {
          this.expandCard();
        });
      }
      else {
        this.expandCard();
      }
    }
  }

  createLocationCards() {
    const { locations, project } = this.state;

    if (locations && locations.length > 0) {
      locations.sort((p1, p2) => {
        return p1.name < p2.name ? -1 : p1.name > p2.name ? 1 : 0;
      });
      return locations.map(location => {
        // let digest = 'por-location-child-card-' + (project ? project.id : 'empty') + '-' + (location ? location.id : 'empty');
        let digest = 'por-location-child-card-' + (project ? project.id : 'empty') + '-' + (location ? location : 'empty');
        return <PORLocationChildCard id={digest} location={location} key={digest} selectLocation={this.handleSelectLocation}
          project={project}
          selected={this.props.selectedLocationId == location.id && this.props.selectedProjectId == project.id} editLocation={this.handleEditLocation} history={this.props.history}/>;
      });
    }
    else {
      return [<PORLocationChildCard id={'none'} noLocations={true} location={null} key={'none'} />];
    }
  }

  expandCard() {
    const height = this.state.locations && this.state.locations.length > 0 ? (this.state.locations.length * 66) : 66;
    return anime({
      targets: this.card,
      height: height,
      easing: 'easeInOutCubic',
      duration: 500,
      complete: () => {
        this.setState({ expanded: true });
      },
    });
  }

  collapseCard() {
    this.setState({ collapsing: true });
    return anime({
      targets: this.card,
      height: 0,
      easing: 'easeInOutCubic',
      duration: 1000,
      complete: () => {
        this.setState({ expanded: false, collapsing: false });
      },
    });
  }
  
  handleEditLocation(location) {
    if (this.props.editLocation) {
      this.props.editLocation(location);
    }
  }

  render() {
    let { selected } = this.props;

    let { project, expanded } = this.state;
    if (!project) {
      return null;
    }
    
    let locationCards = this.createLocationCards();
    return (
      <div
        key={'por-project-parent-card-' + project.id}
        id={this.props.id}
        className={'por-project-parent-card-outer ' + (expanded ? ' expanded' : '')}>
        <div className={'por-project-parent-card ' + (selected ? ' selected' : '')}
          onClick={this.handleProjectSelection}
        >
          <div className="project-parent-box">
            <div className="project-parent-info">
              <div className="project-parent-name">
                {project.name.toUpperCase()}
              </div>
              {project.address ?
                (<div className="project-parent-address">
                  {project.address}
                </div>) : null
              }
              <div className="project-parent-id">
                {'ID: ' + project.guid}
              </div>
            </div>
            <div className={'project-parent-expand-collapse' + (expanded ? ' expanded' : '')}
              onClick={this.handleProjectExpandContract}/>
          </div>
          </div>
          <div className={'por-locations' + (expanded ? ' expanded' : '')}
            ref={el => this.card = el}
          >
            {locationCards}
          </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permissions: state.new_users.permissions,
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
  };
};

export default connect(mapStateToProps)(PORProjectParentCard);



// WEBPACK FOOTER //
// ./src/containers/PORContainer/PORNav/PORProjectParentCard/index.js